
import ClickOutside from 'vue-click-outside'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'
import { Data, Methods, Computed, Props, LinguagemPtBR } from './SeletorDeData.modelo'
import Vue from 'vue'

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'SeletorDeData',
  components: { DatePicker },
  props: {
    value: [String, Date, Array],
    label: {
      type: String,
      default: ''
    },
    selecionarIntervalo: {
      type: Boolean,
      default: false
    },
    dataMinima: {
      type: Date
    },
    dataMaxima: {
      type: Date
    }
  },
  data () {
    return {
      mostrarCalendario: false,
      configuracao: this.realizarConfiguracaoDeAcordoComLinguagem(),
      mensagemErro: null
    }
  },
  computed: {
    dataInput: {
      get () {
        if (this.selecionarIntervalo) {
          return this.value ? `${moment((this.value as Date[])[0]).format('DD/MM/YYYY')} - ${moment((this.value as Date[])[1]).format('DD/MM/YYYY')}` : ''
        }
        return this.value ? moment(this.value as Date).format('DD/MM/YYYY') : ''
      },
      set (value) {
        if (this.selecionarIntervalo) {
          const datas = value.split(' - ')
          this.$emit('input', datas.map(data => moment(data, 'DD/MM/YYYY').toDate()))
          return
        }
        const data = moment(value, 'DD/MM/YYYY').toDate()
        if (this.verificarDataAtualEstaDesabilitada(data)) {
          this.mensagemErro = this.$t('comum.inputs.seletorDeData.dataInvalida') as string
          return this.$emit('input', null)
        }
        this.mensagemErro = null
        this.$emit('input', moment(value, 'DD/MM/YYYY').toDate())
      }
    },
    dataComponenteDatePicker: {
      get () {
        if (this.selecionarIntervalo) {
          return this.value ? [moment((this.value as Date[])[0]).toDate(), moment((this.value as Date[])[1]).toDate()] : ''
        }
        return this.value ? moment(this.value as Date).toDate() : ''
      },
      set (value) {
        if (this.selecionarIntervalo) {
          this.$emit('input', (value as Date[]).map(data => moment(data).toDate()))
          return
        }
        this.$emit('input', moment(value as Date | string).toDate())
        this.mensagemErro = null
      }
    }
  },
  methods: {
    verificarDataAtualEstaDesabilitada (data) {
      const formatoInvalido = moment(data, 'DD/MM/YYYY', true).isValid() === false
      if (formatoInvalido) {
        return true
      }

      if (this.dataMinima && this.dataMaxima) {
        const dataEhMenorQueDataMinima = moment(data).isBefore(this.dataMinima, 'day')
        const dataEhMaiorQueDataMaxima = moment(data).isAfter(this.dataMaxima, 'day')
        return dataEhMenorQueDataMinima || dataEhMaiorQueDataMaxima
      }
      if (this.dataMinima) {
        const dataEhMenorQueDataMinima = moment(data).isBefore(this.dataMinima, 'day')
        return dataEhMenorQueDataMinima
      }
      if (this.dataMaxima) {
        const dataEhMaiorQueDataMaxima = moment(data).isAfter(this.dataMaxima, 'day')
        return dataEhMaiorQueDataMaxima
      }
    },
    realizarConfiguracaoDeAcordoComLinguagem (): LinguagemPtBR | {} {
      const idiomaBateponto = localStorage.getItem('idiomaBatePonto')
      const ptBr = {
        formatLocale: {
          monthsShort: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
          weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
        }
      }
      return idiomaBateponto === 'en' ? {} : ptBr
    },
    controlarVisibilidadeCalendario () {
      this.mostrarCalendario = !this.mostrarCalendario
    },
    fecharCalendario () {
      this.mostrarCalendario = false
    }
  },
  directives: {
    ClickOutside
  }
})
